import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "font-medium leading-tight mt-2" }
const _hoisted_2 = {
  key: 0,
  class: "text-right"
}
const _hoisted_3 = { class: "text-base text-gray-400" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Пин - ")
const _hoisted_5 = { class: "font-bold text-black tracking-wider" }
const _hoisted_6 = { class: "text-xs leading-tight text-gray-400" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Ячейка - ")
const _hoisted_8 = { class: "font-bold text-black" }

import { computed, PropType, ref } from "vue";

import { useRequests } from "@/use/useRequests";
import { IRequest } from "@/types/request";
import { formatCurrency } from "@/utils";

import UiCell from "@/plugins/ui/components/cell/UiCell.vue";
import UiIcon from "@/plugins/ui/components/icon/UiIcon.vue";

import RequestPreviewModal from "./RequestPreviewModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestCell',
  props: {
  request: { type: Object as PropType<IRequest>, required: true },
},
  setup(__props) {

const props = __props



const { getRequestStatus } = useRequests();

const showModal = ref(false);

const isActiveRequest = computed(() =>
  ["accept", "wait"].includes(props.request.status)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(UiCell, _mergeProps(_ctx.$attrs, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = true))
    }), {
      left: _withCtx(() => [
        (__props.request.status === 'accept')
          ? (_openBlock(), _createBlock(UiIcon, {
              key: 0,
              icon: "CheckCircle",
              class: "text-green-500"
            }))
          : (__props.request.status === 'cancel')
            ? (_openBlock(), _createBlock(UiIcon, {
                key: 1,
                icon: "Ban",
                class: "text-red-500"
              }))
            : (__props.request.status === 'eject')
              ? (_openBlock(), _createBlock(UiIcon, {
                  key: 2,
                  icon: "XCircle",
                  class: "text-yellow-500"
                }))
              : (__props.request.status === 'reject')
                ? (_openBlock(), _createBlock(UiIcon, {
                    key: 3,
                    icon: "X",
                    class: "text-red-500"
                  }))
                : (__props.request.status === 'success')
                  ? (_openBlock(), _createBlock(UiIcon, {
                      key: 4,
                      icon: "CheckCircle",
                      class: "text-green-500"
                    }))
                  : (_openBlock(), _createBlock(UiIcon, {
                      key: 5,
                      icon: "Clock",
                      class: "text-blue-500"
                    }))
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", null, " Заказ " + _toDisplayString(__props.request.recess.begin.slice(0, 5)) + "-" + _toDisplayString(__props.request.recess.end.slice(0, 5)), 1),
        _createElementVNode("p", {
          class: _normalizeClass(["text-xs", {
          'text-green-500': __props.request.status === 'accept',
          'text-red-500': __props.request.status === 'cancel',
          'text-yellow-500': __props.request.status === 'eject',
          'text-red-500': __props.request.status === 'reject',
          'text-green-500': __props.request.status === 'success',
          'text-blue-500': __props.request.status === 'wait',
        }])
        }, _toDisplayString(_unref(getRequestStatus)(__props.request.status)), 3),
        _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(formatCurrency)(__props.request.operation.sum / 100)), 1)
      ]),
      right: _withCtx(() => [
        (_unref(isActiveRequest))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("span", _hoisted_5, _toDisplayString(__props.request.pin), 1)
              ]),
              _createElementVNode("p", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("span", _hoisted_8, _toDisplayString(__props.request.position.number), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16),
    _createVNode(RequestPreviewModal, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showModal).value = $event)),
      request: __props.request
    }, null, 8, ["modelValue", "request"])
  ], 64))
}
}

})